<template>
  <div class="login-detail">

    <br>
    <br>
    <br>
    <br>
    <br>
<fun :fundata="isLoadingToast" @fashe='isLoadingToast.value=false'></fun>
<fun :fundata="isDialog" @fashe='isDialog.value=false'></fun>



      <div class="logins-admin">
        <div class="lgoins-admin-item1">账号</div>
        <input class="lgoins-admin-item2"  v-model="info.tel" placeholder="请填写账号" @keydown.enter="admin" @blur="blur" @focus="focus">
        <div class="icons">
        <span class="icon icon-72" v-show="info.tel" @click="info.tel=''"></span>
        </div>
      </div>

    <div class="logins-admin">
      <div class="lgoins-admin-item1">密码</div>
      <input class="lgoins-admin-item2" type="password" v-model="info.psd" placeholder="请填写密码" @keydown.enter="admin">
      <div class="icons">
        <span class="icon icon-72" v-show="info.psd" @click="info.psd=''"></span>
      </div>
    </div>
<br>
<br>

<br>
    <div @click="admin" :class="info.tel&&info.psd?'logindetail-btn':'logindetail-btns'" :style="{
      backgroundColor:isgray?'#cecece':''
    }">登
      录</div>

  </div>
</template>

<script>
  import {Howl, Howler} from 'howler';
var sounds = new Howl({
  src: ['./static/点击.mp3'],
  volume: 0.1
});
import axios from '@/js/axios.js'
import fun from '@/components/common/fun'
  export default {
    data() {
      return {
        isgray: false,
        isLoadingToast:{name:'LoadingToast',msg:'登录中',value:false},
        isDialog:{name:'Dialog',msg:'用户名或密码错误',value:false},
        info: {
          tel: '',
          psd: '',
        },
      }
    },
    components:{fun},
    created(){
      
      let count = JSON.parse(localStorage.getItem('count'));
      if(count){
        this.info = count;
      }
    },
    methods: {
      admin() {
        
        if(!(this.info.tel&&this.info.psd)) return      

        let hf = window.location.pathname;
			let hfarr = hf.split('/')
			let website = hfarr[hfarr.length - 1];


       this.isLoadingToast.value = true;
        

          axios.post('/logins/qdlogin',{website,...this.info} ).then(res => {

             this.isLoadingToast.value = false;
       
              if(res.code ==200){
                this.$router.push('/');
                localStorage.setItem('count',JSON.stringify(this.info));
                this.$store.state.account = this.info.tel;
              }else{
                weui.alert("账号或密码有误,请检查!");
                localStorage.removeItem('count');

              }
          }).catch(res=>{
            this.isLoadingToast.value = false;
            weui.alert('无法登录！')
          });


      
        this.isgray = true;
        setTimeout(() => {
          this.isgray = false
        }, 100)
       /* this.isLoadingToast.value = !this.isLoadingToast.value */

      },
      blur(e){
        // if(!/^1[^2]\d{9}$/.test(e.target.value)){
        //   e.target.style.color = 'red'
        // }
      },
      focus(e){
        e.target.style.color = ''
      }
    }
  }
</script>

<style lang='less'>
  .login-detail {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    width: 100%;
    top: 0;
    background-color: white;
    height: 100vh;
    z-index: 3;

    .logins-admin {
      flex-shrink: 0;
      display: flex;
      align-items: flex-end;
      width: 90%;
      height: 40px;
      font-size: 18px;
      border-bottom: 1px solid #f2f2f2;

      .lgoins-admin-item1 {
        /*    flex-shrink: 0; */
        height: 40px;
        display: flex;
        align-items: center;
        width: 80px;
      }
      .lgoins-admin-item2 {
        flex: 1;
        height: 40px;
       display: flex;
        align-items: center;

        border: none;
        outline: none;
        font-size: 18px;
      }
      .icons{
        width: 30px;
      }
    }
    .logindetail-btns {
      height: 38px;
      width: 80%;
      background-color: #cecece;
      border-radius: 5px;
      color: #ffffff;
      font-size: 18px;
      line-height: 38px;
      text-align: center;

    }

    .logindetail-btn {
      height: 38px;
      width: 80%;
      background-color: #0289ff;
      border-radius: 5px;
      color: #ffffff;
      font-size: 18px;
      line-height: 38px;
      text-align: center;

    }
  }

</style>



// WEBPACK FOOTER //
// src/login/detail/logindetail.vue